<template>
  <div>
    <div style="margin-left: 38px; margin-top: 17px">
      <div class="condition">纳排标准</div>

      <!-- 高级查询搜索 -->
      <!-- <div style="width: 100%; display: flex; justify-content: flex-end">
        <el-button type="primary" @click="onSave" class="czhi">

          保存
        </el-button>
        <el-button style="margin-right: 100px" @click="onRestFz" class="czhi">

          重置
        </el-button>
      </div> -->
      <el-collapse v-model="activeNames" @change="handleChange">
        <template>
          <!-- <div>显示的文本</div> -->
          <el-collapse-item :title="itemx.Name ? '问卷——' + itemx.Name : ''" :name="indexx" v-for="(itemx, indexx) in testArr" :key="indexx">
            <!-- 内容 -->
            <div style="color: red" v-if="itemx.ProjectRuleList?.length == 0">暂未添加纳排标准</div>
            <div v-if="itemx.ProjectRuleList?.length != 0" style="display: flex; margin-top: 20px">
              <!-- <div style="margin-left: 40px">纳排备注：</div> -->
              <el-input readonly :autosize="{ minRows: 2, maxRows: 10 }" show-word-limit style="width: 75%; font-size: 14px" v-model="itemx.Remarks" type="textarea" placeholder=""></el-input>
              <!--
              <div class="tox" v-html="itemx.Remarks"></div> -->
            </div>
          </el-collapse-item>
        </template>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { opAndOr, opAndOrObj, opRelations, opRelations2, opRelationsObj, optionsTime } from '@/utils/dictionary.js';
import naPai from '../../api/naPai';
import smartSearch from '../../api/smartSearch.js';
export default {
  data() {
    return {
      optionsToshow: {},
      ProjectId: this.$route.query.Id,
      activeNames: [],
      options: [],
      opRelations: opRelations,
      opRelations2: opRelations2,
      opAndOr: opAndOr,
      optionsTime: optionsTime,
      testArr: [
        { name: '表一', arr: [1, 2, 3] },
        { name: '表二', arr: [1, 2] }
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleChange(val) {
      console.log(val, this.activeNames, 78);
    },

    // const result = [];
    // for (const item of array) {
    //   const existingItem = result.find(obj => obj.QName === item.QName);
    //   if (existingItem) {
    //     existingItem.data.push(item);
    //   } else {
    //     result.push({ QName: item.QName, data: [item] });
    //   }
    // }

    toClear() {
      this.nbForm = [
        {
          ConditionalType: '',
          Vaule: '',
          EventConditional: 0
        }
      ];
      console.log(123456);
    },
    getData() {
      naPai.GetProjectRuleListByProjectId(this.ProjectId).then(e => {
        if (e.data.Status == -1) {
          this.$message.error(e.data.Message);
          return;
        }
        console.log(e.data);
        // 处理数据，让数据变成文本格式
        e.data.forEach((item, index) => {
          if (item.ProjectRuleList.length) {
            console.log(item.ProjectRuleList);
            item.ProjectRuleList.forEach((itemx, indexx) => {
              if (indexx == 0) {
                itemx.showText = '1.';
                itemx.showText += this.optionsToshow[itemx.DataMappingId];
                // 预支范围
                if (itemx.ConditionalType == 8) {
                  itemx.showText += ' ' + opRelationsObj[itemx.ConditionalType] + '最大值为 ' + itemx.MinVaule + '最小值 ' + itemx.MaxVaule;
                } else {
                  itemx.showText += ' ' + opRelationsObj[itemx.ConditionalType] + ' ' + itemx.Vaule;
                }
              } else {
                itemx.showText = indexx + 1 + '.' + opAndOrObj[itemx.SelectType];
                itemx.showText += this.optionsToshow[itemx.DataMappingId];
                // 预支范围
                if (itemx.ConditionalType == 8) {
                  itemx.showText += ' ' + opRelationsObj[itemx.ConditionalType] + '最大值为 ' + itemx.MinVaule + '最小值 ' + itemx.MaxVaule;
                } else {
                  itemx.showText += ' ' + opRelationsObj[itemx.ConditionalType] + ' ' + itemx.Vaule;
                }
              }
            });
          }
        });
        console.log(e.data, 7788);

        const arr = [];
        e.data.forEach((item, index) => {
          arr.push(index);
        });
        this.activeNames = arr;
        this.testArr = e.data;
        console.log(this.activeNames);
        console.log(this.testArr);
      });
    },
    onSave() {
      // const params = {
      //   id: this.ProjectId,
      //   data: { projectRuleEntity: this.nbForm }
      // };
      // console.log(params);
      naPai.AddList(this.ProjectId, this.nbForm).then(e => {
        this.$message.success('保存成功');
      });
      console.log(this.nbForm);
    },
    // 查询条件下拉查询 现在  **********************
    getList() {
      this.selectLoading = true;
      smartSearch.GetList().then(e => {
        this.getData();
        this.selectLoading = false;

        this.options = e.data;
        this.optionsToshow = e.data.reduce((obj, item) => {
          obj[item.Id] = item.Name;
          return obj;
        }, {});
        console.log(this.optionsToshow);
      });
    },
    onRestFz() {
      this.nbForm = [
        {
          ConditionalType: '',
          Vaule: '',
          EventConditional: 0
        }
      ];
    },
    toAdd(item, index) {
      this.nbForm.push({
        ConditionalType: '',
        Vaule: '',
        SelectType: '',
        MaxVaule: '',
        MinVaule: '',
        EventConditional: 0
      });
    },
    // 高级关系
    changeRelation(val, index) {
      const arr = ['Vaule', 'MinVaule', 'MaxVaule', 'EventDay', 'EventDataMappingId', 'EventConditionalType', 'EventVaule'];
      arr.forEach(e => {
        this.$set(this.nbForm[index], e, '');
      });
      console.log(val, index);
    },
    changeRelations(val, index) {
      const arr = ['EventVaule'];
      arr.forEach(e => {
        this.$set(this.nbForm[index], e, '');
      });
      console.log(val, index);
    },
    timeChange(item, index) {
      const arr = ['EventDay', 'EventDataMappingId', 'EventConditionalType', 'EventVaule'];
      arr.forEach(e => {
        this.$set(this.nbForm[index], e, '');
      });
      // this.$set(this.nbForm);
      console.log(item, index);
    },
    toDel(item, index) {
      if (this.nbForm.length === 1) {
        this.nbForm = [
          {
            ConditionalType: '',
            Vaule: '',
            EventConditional: 0
          }
        ];
        return;
      }
      this.nbForm.splice(index, 1);
      console.log(item, index);
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
  .demo-form-inline {
    .el-form-item {
      margin-right: 0;
    }
  }
  ::v-deep() {
    .el-form-item {
      margin-right: 10px !important;
    }
  }
}
.nbSearch {
  .nbSearch_child {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 15px;
    & > div:first-child {
      margin-right: 10px;
    }
    ::v-deep() {
      .el-select {
        margin-right: 10px !important;
      }
    }
  }
}
.flexAll {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #409eff;
  cursor: pointer;
}
.flexAll_end {
  height: 100%;
  display: flex;
  align-items: center;
}

.opAndOr {
  width: 100px;
}
.inputChose {
  width: 200px;
  margin-right: 10px;
}
.iconRight {
  margin-right: 5px;
}

.condition {
  color: #333333;
  font-size: 20px;
  padding: 0 8px;
  border-left: 3px solid #3388ff;
}
.czhi {
  /* background: #fff !important; */
}
/deep/ .el-collapse-item__header {
  font-size: 20px;
}
.tox {
  border: 1px solid #ccc;
  width: 50%; /* 子级宽度 */
  padding: 10px 25px;
  max-height: calc(10 * 1.2em); /* 最多显示五行文本，每行高度为 1.2em */
  line-height: 1.5em; /* 行高 */
  text-indent: 2em; /* 首行缩进两字符 */
  /* 添加阴影效果 */
  box-shadow: 0 0 10px #a1b6d4; /* 阴影的颜色、模糊度等属性 */
  height: 500px;
  -webkit-box-orient: vertical; /* 垂直方向排列 */
  -webkit-line-clamp: 10; /* 最多显示五行 */
  overflow: auto; /* 超出部分隐藏 */
}
::-webkit-scrollbar-thumb {
  background-color: #b3d8ff;
  border-radius: 10px; /*滚动条的圆角*/
}
/deep/ .el-textarea__inner {
  box-shadow: 0 0 5px #d4ddeb; /* 阴影的颜色、模糊度等属性 */
}
</style>
